<p-dialog
  #fastMarca
  [modal]="true"
  [visible]="true"
  (visibleChange)="dialogRef.close()"
  [breakpoints]="{ '1199px': '75vw', '575px': '90vw' }"
  [maximizable]="true"
  [closable]="true"
  [responsive]="true"
  [closeOnEscape]="false"
  [dismissableMask]="false"
>
  <ng-template pTemplate="header">
    <div class="flex aling-items-center">
      <span class="font-light fs-normal">Adicionar marca</span>
      <i class="mdi mdi-marker-check ml-2 text-primary"></i>
    </div>
  </ng-template>
  <div class="row p-2 mt-2">
    <div class="col-md-12">
      <span class="p-float-label">
        <input
          id="inputtext-nome"
          class="input-filters"
          pInputText
          [formControl]="form.get('nome')"
          (blur)="actionFnCheckEntityExist(form.get('nome'))"
          type="text"
          autocomplete="off"
        />
        <label for="inputtext-nome">Nome *</label>
      </span>
      <small class="p-error" *ngIf="form.get('nome').hasError('required')">
        {{ displayMessage.nome.duplicate }}
      </small>
      <small class="p-error" *ngIf="form.get('nome').hasError('required')">
        {{ displayMessage.nome.required }}
      </small>
      <small class="p-error" *ngIf="form.get('nome').hasError('maxlength')">
        {{ displayMessage.nome.maxlength }}
      </small>
      <small class="p-error" *ngIf="form.get('nome').hasError('isEmptyValue')">
        {{ displayMessage.nome.isEmptyValue }}
      </small>
    </div>
  </div>
  <ng-template pTemplate="footer">
    <div class="width-100 mb-3 flex align-items-center justify-content-between">
      <button
        pButton
        pRipple
        severity="danger"
        text
        rounded
        (click)="dialogRef.close()"
        label="Cancelar"
        icon="pi pi-fw pi-times-circle"
        iconPos="right"
      ></button>
      <button
        pButton
        pRipple
        severity="success"
        outlined
        rounded
        label="Salvar"
        icon="pi pi-fw pi-save"
        iconPos="right"
        (click)="onSubmit()"
        [disabled]="loading || !form.valid"
      ></button>
    </div>
  </ng-template>
</p-dialog>
